import { Form, Input, Typography } from "antd";

import FormInput from "../Forms/FormInput";
import { MdOutlineArrowOutward } from "react-icons/md";
import { useForm } from "antd/es/form/Form";
import { formRules, variableType } from "../../constant";
import PrimaryButton from "../Forms/PrimaryButton";

const { Title } = Typography;

const PartyCode = ({ handleSubmit, modelType, loading, formData }) => {
  const [form] = useForm();

  const onFinish = (values) => {
    handleSubmit(values);
  };

  return (
    <>
      <Title level={2} className="w-full font-abhaya">
        {modelType == variableType.codeName ? "Party Code" : "Change Password"}
      </Title>
      <Form
        name="trigger"
        layout="vertical"
        autoComplete="off"
        form={form}
        onFinish={onFinish}
        initialValues={formData}
      >
        {/* <Form.Item label="Password" name="password" rules={formRules.password}>
            <Input.Password size="large" />
          </Form.Item> */}
        {modelType == variableType.codeName ? (
          <FormInput
            label="Enter Party Code"
            className={"h-[47.6px]"}
            name="party_code"
            rules={formRules.partyCode}
            maxLength={10}
          />
        ) : (
          <Form.Item label="Password" name="new_password" rules={formRules.password}>
            <Input.Password size="large" className={"h-[47.6px]"} maxLength={20} />
          </Form.Item>
        )}
        <div className="w-full mt-4 flex justify-center">
          <PrimaryButton
            text={"Save and Proceed"}
            type="submit"
            loading={loading}
            className="me-[30px]"
          />
        </div>
      </Form>
    </>
  );
};

export default PartyCode;
